import { Action } from '@ngrx/store';

export class LiveStreamAction implements Action {

    public static getLive = '[Live Stream] get_live';
    public static getLiveError = '[Live Stream] get_live_error';
    public static getLiveSuccess = '[Live Stream] get_live_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
